import { Button, Input, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useMessage } from "../../../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../../../Components/axiosInstance/AxiosInstance";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";

export default function EditAmmafos({
  isModalOpen,
  setIsModalOpen,
  getData,
  id,
}) {
  let [data, setData] = useState({
    ticket: {
      date: null,
      ticket: null,
    },
    believer: {
      id: null,
      name: null,
      date: null,
    },
    ykx: {
      date: null,
      ykx: null,
    },
    name: null,
    organization: "Омбор",
    INN: null,
    product: "Аммофос",
    price: null,
    comment: null,
    tonna: null,
  });

  let [names, setNames] = useState([]);
  const getNames = async () => {
    try {
      setLoading(true);

      let info = await axiosInstance.get("/api/add-product");

      console.log("info");
      console.log(info);

      if (info.data.success) {
        setNames(info.data.data);
      }
    } catch (error) {
      // getNames();
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNames();
  }, []);

  let [loading, setLoading] = useState(false);
  const messageApi = useMessage();

  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const handleKeyDown = (e, index) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      // Prevent date value from changing
      if (e.target.type === "date") {
        e.preventDefault();
      }
      if (e.key === "ArrowDown") {
        // Focus the next input (if it exists)
        if (index < inputRefs.length - 1) {
          inputRefs[index + 1].current.focus();
        }
      } else if (e.key === "ArrowUp") {
        // Focus the previous input (if it exists)
        if (index > 0) {
          inputRefs[index - 1].current.focus();
        }
      }
    }
  };

  let restore = () => {
    console.log(JSON.parse(localStorage.getItem("ammafos_data")));
    setData(JSON.parse(localStorage.getItem("ammafos_data")));
  };

  useEffect(() => {
    if (
      data.name ||
      data.price ||
      data.INN ||
      data.tonna ||
      data.ykx.date ||
      data.believer.id
    ) {
      localStorage.setItem("ammafos_data", JSON.stringify(data));
    }
  }, [data]);

  useEffect(() => {
    if (isModalOpen && localStorage.getItem("ammafos_data")) {
      restore();
    }
  }, [isModalOpen]);

  let uploadData = async () => {
    try {
      setLoading(true);

      let { data: info } = await axiosInstance.put(
        "/api/chiqim-official/ammafos-kaliy/" + id,
        {
          ...data,
        }
      );
      if (info.success) {
        console.log("data");
        console.log(info);
        setData(data);
        getData();
        setIsModalOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleConnection = async (value) => {
    try {
      let { data: info } = await axiosInstance.get(
        "/api/chiqim-official/ammafos-kaliy/" + id
      );
      console.log(info);
      if (info.success) {
        setData({
          ticket: {
            date: info?.data?.ticket?.date,
            ticket: info?.data?.ticket?.ticket,
          },
          believer: {
            id: info?.data?.believer?.id,
            name: info?.data?.believer?.name,
            date: info?.data?.believer?.date,
          },
          ykx: {
            date: info?.data?.ykx?.date,
            ykx: info?.data?.ykx?.ykx,
          },
          name: info?.data?.name,
          organization: info?.data?.organization,
          INN: info?.data?.INN,
          product: info?.data?.product,
          price: info?.data?.price,
          tonna: info?.data?.tonna,
          comment: info?.data?.comment,
        });
        // setIsModalOpen(false);
      }
      console.log(info);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      handleConnection();
    }
  }, [isModalOpen]);
  return (
    <Modal
      style={{ top: "10px" }}
      title="Ticketni o'qgartirish"
      open={isModalOpen}
      loading={data ? false : true}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setIsModalOpen(false);
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            localStorage.setItem(
              "ammafos_data",
              JSON.stringify({
                ticket: {
                  date: null,
                  ticket: null,
                },
                believer: {
                  id: null,
                  name: null,
                  date: null,
                },
                ykx: {
                  date: null,
                  ykx: null,
                },
                name: null,
                INN: null,
                product: "Аммофос",
                price: null,
                tonna: null,
              })
            );
            setIsModalOpen(false);
          }}
          style={{ backgroundColor: "#f5222d", color: "#fff" }}
        >
          Tozalash
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            console.log(data);
            uploadData();
          }}
        >
          Saqlash
        </Button>,
      ]}
    >
      {/* <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">yozdi</p> */}
      <div>
        <div className="bg-[#bfbfbf] p-2 rounded-lg">
          <label className="text-[16px] block ">ЎзРТХБ шартномаси </label>
          <label className="text-[12px] ">Ticket Sana</label>
          <Input
            type="date"
            placeholder="time"
            value={data?.ticket?.date?.split("T")[0]}
            ref={inputRefs[0]}
            onKeyDown={(e) => {
              handleKeyDown(e, 0);
              if (e.key === "F2") {
                const currentDate = new Date().toISOString(); // Get current date in YYYY-MM-DD format
                setData({
                  ...data,
                  ticket: { ...data.ticket, date: currentDate },
                });
              }
            }}
            onChange={(e) => {
              console.log(e.target.value);
              setData({
                ...data,
                ticket: { ...data.ticket, date: e.target.value },
              });
            }}
            onPaste={(e) => {
              const pastedData = e.clipboardData.getData("text");
              let formatted = moment(pastedData, "DD.MM.YYYY").format(
                "YYYY-MM-DD"
              );
              setData({
                ...data,
                ticket: { ...data.ticket, date: formatted },
              });
            }}
          />
          <label className="text-[12px] ">Ticket raqami</label>
          <Input
            type="text"
            placeholder="Ticket raqami"
            autoFocus={true}
            value={data.ticket.ticket}
            ref={inputRefs[1]}
            onKeyDown={(e) => {
              handleKeyDown(e, 1);
            }}
            onChange={(e) => {
              setData({
                ...data,
                ticket: { ...data.ticket, ticket: e.target.value },
              });
            }}
          />
        </div>
        <label className="text-[16px] ">Tshkilot / Korxona</label>
        <Input
          type="text"
          placeholder="Tshkilot / Korxona"
          value={data.organization}
          ref={inputRefs[2]}
          onKeyDown={(e) => {
            handleKeyDown(e, 2);
          }}
          onChange={(e) => {
            setData({
              ...data,
              organization: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Klient</label>
        <Input
          type="text"
          placeholder="Klient nomi"
          value={data.name}
          ref={inputRefs[2]}
          onKeyDown={(e) => {
            handleKeyDown(e, 2);
          }}
          onChange={(e) => {
            setData({
              ...data,
              name: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">INN</label>
        <Input
          type="text"
          placeholder="INN"
          value={data.INN}
          ref={inputRefs[3]}
          onKeyDown={(e) => {
            handleKeyDown(e, 3);
          }}
          onChange={(e) => {
            setData({
              ...data,
              INN: e.target.value,
            });
          }}
        />
        <label className="text-[16px] ">Ichonchnoma nomeri</label>
        <Input
          type="text"
          placeholder="Ishonchnoma raqami"
          value={data.believer.id}
          ref={inputRefs[4]}
          onKeyDown={(e) => {
            handleKeyDown(e, 4);
          }}
          onChange={(e) => {
            setData({
              ...data,
              believer: { ...data.believer, id: e.target.value },
            });
          }}
        />
        <label className="text-[16px] ">Ichonchli shaxs</label>
        <Input
          type="text"
          placeholder="Shaxs"
          value={data.believer.name}
          ref={inputRefs[5]}
          onKeyDown={(e) => {
            handleKeyDown(e, 5);
          }}
          onChange={(e) => {
            setData({
              ...data,
              believer: { ...data.believer, name: e.target.value },
            });
          }}
        />
        <label className="text-[12px] ">Ichonoma sanasi</label>
        <Input
          type="date"
          placeholder="Yukxati sanasi"
          value={data.believer.date?.split("T")[0]}
          ref={inputRefs[6]}
          onKeyDown={(e) => {
            handleKeyDown(e, 6);
            if (e.key === "F2") {
              const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
              setData({
                ...data,
                believer: { ...data.believer, date: currentDate },
              });
              console.log("Date set to:", currentDate);
            }
          }}
          onChange={(e) => {
            setData({
              ...data,
              believer: { ...data.believer, date: e.target.value },
            });
          }}
          onPaste={(e) => {
            const pastedData = e.clipboardData.getData("text");
            let formatted = moment(pastedData, "DD.MM.YYYY").format(
              "YYYY-MM-DD"
            );
            setData({
              ...data,
              believer: { ...data.believer, date: formatted },
            });
          }}
        />
        <div className="bg-[#bfbfbf] p-2 rounded-lg mt-2">
          <label className="text-[16px] block ">
            Махсулот транспорт юк хати{" "}
          </label>
          <label className="text-[12px] ">Yukxati sanasi</label>
          <Input
            type="date"
            placeholder="Yukxati sanasi"
            value={data.ykx.date?.split("T")[0]}
            ref={inputRefs[6]}
            onKeyDown={(e) => {
              handleKeyDown(e, 6);
              if (e.key === "F2") {
                const currentDate = new Date().toISOString(); // Get current date in YYYY-MM-DD format
                setData({
                  ...data,
                  ykx: { ...data.ykx, date: currentDate },
                });
                console.log("Date set to:", currentDate);
              }
            }}
            onChange={(e) => {
              setData({
                ...data,
                ykx: { ...data.ykx, date: e.target.value },
              });
            }}
            onPaste={(e) => {
              const pastedData = e.clipboardData.getData("text");
              let formatted = moment(pastedData, "DD.MM.YYYY").format(
                "YYYY-MM-DD"
              );
              setData({
                ...data,
                ykx: { ...data.ykx, date: formatted },
              });
            }}
          />
          <label className="text-[12px] ">Yukxati raqami</label>
          <Input
            type="text"
            placeholder="Yukxati raqami"
            value={data.ykx.ykx}
            ref={inputRefs[7]}
            onKeyDown={(e) => {
              handleKeyDown(e, 7);
            }}
            onChange={(e) => {
              setData({
                ...data,
                ykx: { ...data.ykx, ykx: e.target.value },
              });
            }}
          />
        </div>
        <label className="text-[16px] ">Yuk nomi</label>
        {/* <Input
          type="text"
          placeholder="Yukxati raqami"
          value={data.product}
          ref={inputRefs[8]}
          onKeyDown={(e) => {
            handleKeyDown(e, 8);
          }}
          onChange={(e) => {
            setData({
              ...data,
              product: e.target.value,
            });
          }}
        /> */}
        <select
          id="options"
          value={data.product}
          ref={inputRefs[10]}
          onKeyDown={(e) => {
            handleKeyDown(e, 10);
          }}
          onChange={(e) => {
            // console.log(e.target.value.split("\t"));
            setData({
              ...data,
              product: e.target.value,
            });
          }}
          class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
        >
          <option value="">Dori turi</option>
          {names
            ? names?.map((el) => {
                return <option value={el.name}>{el.name}</option>;
              })
            : null}
        </select>
        <label className="text-[16px] ">Yuk Tonnasi</label>
        <Input
          type="text"
          placeholder="Yuk Tonnasi"
          value={data.tonna}
          ref={inputRefs[9]}
          onKeyDown={(e) => {
            handleKeyDown(e, 9);
          }}
          onChange={(e) => {
            setData({
              ...data,
              tonna: e.target.value.split(",").join("."),
            });
          }}
        />
        <label className="text-[16px] ">Yuk Qiymati</label>
        <Input
          type="text"
          placeholder="Yuk Qiymati"
          value={data.price}
          ref={inputRefs[10]}
          onKeyDown={(e) => {
            handleKeyDown(e, 10);
          }}
          onChange={(e) => {
            setData({
              ...data,
              price: e.target.value.split(",").join("."),
            });
          }}
        />
        <label className="text-[16px] ">Izoh</label>
        <TextArea
          rows={4}
          placeholder="Type your text here..."
          value={data.comment}
          ref={inputRefs[13]}
          onKeyDown={(e) => {
            handleKeyDown(e, 13);
          }}
          onChange={(e) => {
            setData({
              ...data,
              comment: e.target.value,
            });
          }}
        />
      </div>
    </Modal>
  );
}
